import { ref, reactive, onMounted, toRefs } from "vue";
import { getCurrentInstance } from "vue";
import apis from "@/api";
export default {
  name: "LoginLogComponent",
  setup() {
    const {
      proxy
    } = getCurrentInstance();
    const data = reactive({
      queryParam: {
        empName: "",
        userType: "",
        mobile: "",
        status: "",
        startTime: "",
        endTime: ""
      },
      defaultDateTime: new Date(2000, 2, 1, 23, 59, 59),
      pageNo: 1,
      pageSize: 10,
      tableData: [],
      allData: [],
      columns: [{
        label: "ID",
        prop: "traceId"
      }, {
        label: "创建时间",
        prop: "startTime"
      }, {
        label: "结束时间",
        prop: "endTime"
      }, {
        label: "用户ID",
        prop: "userId"
      }, {
        label: "用户地市",
        prop: "city"
      }, {
        label: "渠道",
        prop: "channel"
      }, {
        label: "登录方式",
        prop: "loginType"
      }, {
        label: "状态",
        prop: "result"
      }],
      total: 0,
      currentPage: 1,
      searchFlag: false
    });
    const loadData = () => {
      apis.listLoginLogs({
        pageNo: data.pageNo,
        pageSize: data.pageSize,
        queryParam: data.queryParam
      }).then(res => {
        data.total = res.data.total;
        data.tableData = res.data.records;
      });
    };
    const resetForm = form => {
      proxy.$refs[form].resetFields();
      data.currentPage = 1;
      submitForm(form);
    };
    const submitForm = form => {
      proxy.$refs[form].validate(valid => {
        if (valid) {
          loadData();
          data.searchFlag = true;
        } else {
          return false;
        }
      });
    };
    const sizeChange = pageSize => {
      this.pageSize = pageSize;
      this.currentChange(this.currentPage);
    };
    const currentChange = currentPage => {
      if (data.searchFlag) {
        apis.listLoginLogs({
          pageNo: currentPage,
          pageSize: data.pageSize,
          queryParam: data.queryParam
        }).then(res => {
          data.tableData = res.data.records;
          data.currentPage = res.data.current;
          data.total = res.data.total;
        });
      } else {
        apis.listLoginLogs({
          pageNo: currentPage,
          pageSize: data.pageSize,
          queryParam: data.queryParam
        }).then(res => {
          data.tableData = res.data.records;
          data.currentPage = res.data.current;
          data.total = res.data.total;
        });
      }
    };
    onMounted(() => {
      loadData();
      console.log("初始化查询开始------------");
    });
    return {
      ...toRefs(data),
      proxy,
      loadData,
      resetForm,
      submitForm,
      currentChange,
      sizeChange
    };
  }
};